import React, { useEffect } from "react";
import { Section } from "types/Models/Filing";
import { useInView } from "react-intersection-observer";
import classNames from "classnames";
import { useRoleBasedView } from "hooks/useRoleBasedView"; // Ensure AllFields is imported
import { AllFields } from "./step0";
import { FormTooltip } from "./formControl";
import { Task } from "types/Models/task";

export const FormSections = ({
  section,
  setActiveSectionKey,
  isPricingStep,
  updatedTask,
  formId,
  updateSectionKeyIdPair,
  updateRemovedSectionIds,
  current,
  data,
  uuid,
  groupId,
  isArchived,
  entityId,
  formData,
  task,
  activeSectionKey,
}: {
  section: Section;
  setActiveSectionKey: (sectionKey: string) => void;
  isPricingStep: boolean;
  updatedTask: any;
  formId: string;
  updateSectionKeyIdPair: (args: { key: string; id: number }) => void;
  updateRemovedSectionIds: (args: { key: string; id: number }) => void;
  current: any;
  data: any;
  uuid: string;
  groupId: string;
  isArchived: boolean;
  entityId: string;
  formData: any;
  task: Task;
  activeSectionKey: string;
}) => {
  const { ref, inView } = useInView({
    rootMargin: "0px 0px -600px 0px",
  });
  const { isAdmin } = useRoleBasedView();

  useEffect(() => {
    if (inView) {
      setActiveSectionKey(section.section_key);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id={section.section_key}
      key={section?.section_title}
      className={classNames(
        "t-pb-36 t-border t-border-b-0 t-border-r-0 t-border-t-0 t-border-solid t-border-l-neutral-10",
        {
          "t-pointer-events-none": isPricingStep && !isAdmin,
        }
      )}
    >
      <div className="t-flex t-items-start t-gap-3">
        <div
          className={classNames("t-h-4 t-w-4 t-rounded-full -t-ml-2 t-mr-2", {
            "t-bg-purple-50": activeSectionKey === section.section_key,
            "t-bg-purple-20": activeSectionKey !== section.section_key,
          })}
        ></div>
        <div className="t-text-text-100 t-text-subtext t-leading-4">
          {section?.section_title}{" "}
          {section?.tooltip && (
            <FormTooltip
              tooltipText={
                <div
                  className="t-text-left"
                  dangerouslySetInnerHTML={{
                    __html: section.tooltip,
                  }}
                ></div>
              }
            />
          )}
        </div>
      </div>
      <div className="t-ml-5">
        <AllFields
          updatedTask={updatedTask}
          formId={formId}
          section={section}
          updateSectionKeyIdPair={updateSectionKeyIdPair}
          updateRemovedSectionIds={updateRemovedSectionIds}
          current={current}
          data={data}
          uuid={uuid}
          groupId={groupId}
          isArchived={isArchived}
          entityId={entityId}
          formData={formData}
          deadline={task.deadline}
          season={task.season}
        />
      </div>
    </div>
  );
};
